(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var vs = w.variantStrings;
    if (vs && vs.addToCart && vs.addToCart.indexOf('\uD83D\uDED2') !== 0) vs.addToCart = '\uD83D\uDED2 ' + vs.addToCart;
    var vids = d.querySelectorAll('.pn-section-video video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduce || !('IntersectionObserver' in w)) return;
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { vo.observe(v); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
